import React, { useState } from "react";
import { Box, Button, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ForgotPassword from "features/ForgotPassword";
import ForgotPasswordPhoneNumber from "features/ForgotPasswordPhone/ForgotPasswordPhoneNumber";

export const EMAIL = "email";
export const PHONE = "phone";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(2),
  },
  card: {
    width: "100%",
    maxWidth: 420,
    border: "1px solid #e5e5e5",
    padding: theme.spacing(5, 6),
    marginTop: "4rem",
    marginBottom: "4rem",
  },
  title: {
    fontSize: "2rem",
    fontWeight: "bold",
    letterSpacing: "-0.3px",
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    color: "#5A5A5A",
    marginBottom: theme.spacing(4),
  },
  choiceBtn: {
    justifyContent: "flex-start",
    textTransform: "none",
    fontSize: "1rem",
    padding: theme.spacing(1.75, 2),
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    "&:hover": {
      background: theme.palette.primary.main,
      color: "#fff",
    },
  },
  choiceIcon: {
    marginRight: theme.spacing(1.5),
    fontSize: 20,
  },
  backBar: {
    display: "flex",
    justifyContent: "center",
    paddingTop: theme.spacing(4),
  },
  backBtn: {
    textTransform: "none",
    fontSize: "0.875rem",
    color: "#5A5A5A",
  },
}));

export default function ForgotPasswordEmailOrPhone({
  title = "Reset Password",
  subtitle = "How would you like to reset your password?",
}) {
  const classes = useStyles();
  const [method, setMethod] = useState(null);

  if (!method) {
    return (
      <Box className={classes.root}>
        <Paper elevation={0} className={classes.card}>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.subtitle}>{subtitle}</Typography>

          <Button
            fullWidth
            variant="outlined"
            className={classes.choiceBtn}
            onClick={() => setMethod(EMAIL)}
          >
            <EmailIcon className={classes.choiceIcon} />
            Reset using Email
          </Button>

          <Button
            fullWidth
            variant="outlined"
            className={classes.choiceBtn}
            onClick={() => setMethod(PHONE)}
          >
            <PhoneIcon className={classes.choiceIcon} />
            Reset using Phone Number
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <>
      {method === PHONE ? <ForgotPasswordPhoneNumber /> : <ForgotPassword />}
      <Box className={classes.backBar}>
        <Button
          className={classes.backBtn}
          startIcon={<ArrowBackIcon />}
          onClick={() => setMethod(null)}
        >
          Use a different method
        </Button>
      </Box>
    </>
  );
}
